import React, { Component } from 'react'
import PropTypes from 'prop-types'
import classnames from 'classnames'
import SecondaryNav from '@components/SecondaryNav'
import MobileNavigation from './MobileNavigation'
import './MobileDropdown.module.scss'

class MobileDropdown extends Component {
  state = {
    stopTransition: true
  }

  componentDidMount () {
    setTimeout(() => this.setState({ stopTransition: false }), 500)
  }

  render () {
    const { links, menuToggle, click } = this.props
    const { stopTransition } = this.state

    return (
      <div
        styleName={classnames('mobile-menu', {
          active: menuToggle,
          'stop-transition': stopTransition
        })}
      >
        <MobileNavigation links={links} click={() => click()} />
        <section styleName='secondary-nav'>
          <SecondaryNav click={() => click()} />
        </section>
      </div>
    )
  }
}

MobileDropdown.propTypes = {
  links: PropTypes.arrayOf(PropTypes.string),
  menuToggle: PropTypes.bool,
  click: PropTypes.func
}

MobileDropdown.defaultProps = {
  links: [],
  menuToggle: false,
  click: () => {}
}

export default MobileDropdown



// WEBPACK FOOTER //
// ./src/components/MobileDropdown/MobileDropdown.js